import {ActionWithPayload} from '../../../helpers/reduxHelpers';
import {RoleModel} from '../../../models/api/roleModel';
import {ThunkAction} from '../../appThunk';

/*
 * Action types.
 */

export enum RolesActionsEnum {
  ROLE_UPDATED = '@@data/roles/ROLE_UPDATED',
  ROLE_DELETED = '@@data/roles/ROLE_DELETED',
}

/*
 * Types.
 */

export interface RoleUpdatedAction extends ActionWithPayload<RoleModel> {
  type: RolesActionsEnum.ROLE_UPDATED;
}

export interface RoleDeletedAction extends ActionWithPayload<string> {
  type: RolesActionsEnum.ROLE_DELETED;
}

/*
 * Action creators.
 */

export function updateRole(newRole: RoleModel): ThunkAction {
  return (dispatch, getState) => {
    // Find the existing role.
    const existingRole = getState().data.roles[newRole.alias];

    // No need to do anything if the new role is older.
    if (existingRole && existingRole.updatedAt > newRole.updatedAt) {
      return null;
    }

    const action: RoleUpdatedAction = {
      type: RolesActionsEnum.ROLE_UPDATED,
      payload: {...existingRole, ...newRole},
    };
    return dispatch(action);
  };
}

export function deleteRole(roleAlias: string): ThunkAction {
  return (dispatch, getState) => {
    // If we don't have this signature, nothing to do.
    const existingRole = getState().data.roles[roleAlias];
    if (!existingRole) {
      return null;
    }

    const action: RoleDeletedAction = {
      type: RolesActionsEnum.ROLE_DELETED,
      payload: roleAlias,
    };
    return dispatch(action);
  };
}

/*
 * Union type.
 */

export type RolesAction = RoleUpdatedAction | RoleDeletedAction;
